import React from 'react';

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='container footer-container'>
        <h4 className='footer-text'>
          all &copy; reserved to<span className='brand-color'> drink team</span>
        </h4>
      </div>
    </footer>
  );
};

export default Footer;
